<form (ngSubmit)="doLogin(model)">
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center mb-1">
        <div class="col-md-3 col-sm-4 brand-img"></div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card login-card">
            <div class="card-block login-card-block">
              <h1 class="login-header">Login</h1>
              <div class="row text-muted">
                <div class="col-md-6 text-left">
                  <p>Sign In to your account</p>
                </div>
              </div>
              <div class="input-group mb-1" [ngClass]="{'has-danger': loginerror}">
                <span class="input-group-addon"><i class="fa fa-user"></i> </span>
                <input
                  required
                  type="text"
                  class="form-control"
                  placeholder="Username"
                  name="username"
                  [(ngModel)]="model.username"
                />
              </div>
              <div class="input-group mb-2" [ngClass]="{'has-danger': loginerror}">
                <span class="input-group-addon"><i class="fa fa-lock"></i> </span>
                <input
                  required
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  name="password"
                  [(ngModel)]="model.password"
                />
              </div>
              <div
                *ngIf="loginerror"
                class="input-group mb-1"
                [ngClass]="{'has-danger': loginerror}"
              >
                <div class="form-control-feedback">{{loginmsg}}</div>
              </div>
              <div class="row">
                <div class="col-md-6 text-left my-auto">
                  <button type="submit" class="btn btn-primary px-2" name="Login">Login</button>
                  &nbsp;
                  <button (click)="goToSso()" class="btn btn-primary px-2" name="SsoLogin">
                    SSO Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div *ngIf="loading" id="app-loading" class="opac-loading">
  <div class="loader running"></div>
</div>
<div
  bsModal
  #msgModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="Login Message Modal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4
          class="modal-title pull-left"
          [ngClass]="{ 'text-danger' : expired || sso, 'text-success' : chpwd }"
        >
          <i
            *ngIf="expired || sso"
            class="fa fa-plus-circle fa-3x fa-rotate-45"
            style="vertical-align: -22%;margin-right: 20px;"
          ></i>
          <i
            *ngIf="chpwd"
            class="fa fa-check fa-2x"
            style="vertical-align: -22%;margin-right: 10px;margin-left: 10px;"
          ></i>
          {{redirectTitle}}
        </h4>
        <button
          type="button"
          class="close pull-right"
          name="errorModalCloseButton"
          aria-label="Close"
          (click)="hideChildModal()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="col-sm-12">
          {{redirectMsg}}
        </div>
      </div>
    </div>
  </div>
</div>
